import React, { useEffect, useMemo, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { IoHomeOutline } from "react-icons/io5";
import { AllUsers, GetAllManagerUsers } from "../../utils/proxy/Authproxy";
import Select from "react-select";
import { Op_per } from "../../utils/Permissions";
import { Parser } from "@json2csv/plainjs";
import { RiFileExcel2Fill } from "react-icons/ri";
import { GetVisitDateAnalysis } from "../../utils/proxy/ChartsProxy";
import DataTable from "react-data-table-component";
import LoadingComponent from "../Includes/LoadingComponent";

const VisitDateAnalysis = () => {
     const months = {
          '01':'Jan',
          '02':'Feb',
          '03':'Mar',
          '04':'Apr',
          '05':'May',
          '06':'Jun',
          '07':'Jul',
          '08':'Aug',
          '09':'Sep',
          '10':'Oct',
          '11':'Nov',
          '12':'Dec',
  
      }
  
      const [data, setData] = useState([]);
      const [userid, setUserId] = useState(localStorage.getItem('role') === 'User' ? localStorage.getItem('uuid') : null);
      const [selectedUser, setSelectedUser] = useState();
      const [selectedType, setSelectedType] = useState({ value: 'doctor', label: 'Doctor' });
      const [type, setType] = useState('doctor');
      const [users, setUsers] = useState([]);
      const [start, setStart] = useState();
      const [end, setEnd] = useState();
      const [reload, setReload] = useState(false);
      const [pending, setPending] = useState(false);

  
      useEffect(() => {
          // Fetch data from an API when the component mounts
          const getallusers = async () => {
              if (localStorage.getItem('role') === 'Admin') {
                  let allusers = await AllUsers();
                  allusers.push({ firstname: localStorage.getItem('firstname'), lastname: localStorage.getItem('lastname'), userid: localStorage.getItem('uuid'), username: localStorage.getItem('username') })
                  setUsers(allusers);
              } else if (localStorage.getItem('role') === 'Manager') {
                  let allusers = await GetAllManagerUsers(localStorage.getItem('uuid'));
                  setUsers(allusers);
              }
          };
          getallusers();
      }, []);


  
      useEffect(() => {
          // Fetch data from an API when the component mounts
          const getallteritories = async (userid, from, to, type) => {
              let userteritories = await GetVisitDateAnalysis(
                  userid,
                  from,
                  to,
                  type
              );

              if (userteritories) {
                  setData(userteritories);
                  setPending(false);
              } else {
                  alert("Error", "Issue While Fetching Tour Plan");
              }
          };
          if (userid && start && end) {
              setPending(true);
              getallteritories(userid, start, end, type);
          }
          setReload(false);
      }, [reload, userid, start, end, type]);
  
      const handleSelectChange = (selected) => {
  
          setUserId(selected.value);
          setSelectedUser(selected);
      };
             
  
      const handleTypeChange = (selected) => {
          setSelectedType(selected);
          setType(selected.value);
      }

  

      const handleStartDate = (value) => {
        setStart(value);
      };

    const options = [];
    const typeoptions = [
        { value: 'doctor', label: 'Doctor' },
        { value: 'hospital', label: 'Hospital' },
        { value: 'clinic', label: 'Clinic' },
        { value: 'chemist', label: 'Chemist' },
        { value: 'stockist', label: 'Stockist' },
    ];

    users.map((user) => {
        options.push({
            value: user.userid,
            label: user.username + "(" + user.firstname + " " + user.lastname + ")",
            name: user.username
        });
    });

function downloadVisitCSV(data) {
  if (!data || data.length === 0) {
    alert("No data to export.");
    return;
  }

  const rows = [];

  // Header row (similar to your table structure)
  rows.push([
    "Doctor",
    "Category",
    "Territory",
    "Month",
    "Total Visits In Month",
    "Visit Date",
    "MR Name",
    "Joined With",
    "Sample Product",
    "Remark"
  ]);

  // Loop through data just like your JSX
  data.forEach(doctor => {
    const totalVisits = doctor.months.reduce((acc, m) => acc + m.visitDateAnalysisInners.length, 0);

    let visitCountSoFar = 0;

    doctor.months.forEach(monthObj => {
      monthObj.visitDateAnalysisInners.forEach((visit, visitIdx) => {
        const isFirstVisit = visitCountSoFar === 0;
        const isFirstVisitOfMonth = visitIdx === 0;

        visitCountSoFar++;

        rows.push([
          isFirstVisit ? doctor.dpName : "",
          isFirstVisit ? doctor.category : "",
          isFirstVisit ? doctor.teritory : "",
          isFirstVisitOfMonth ? monthObj.month : "",
          isFirstVisitOfMonth ? monthObj.visitDateAnalysisInners.length : "",
          visit.date,
          visit.mrName,
          visit.joinWorkWith || "N/A",
          visit.productName || "N/A",
          visit.remark?.trim() || "N/A"
        ]);
      });
    });
  });

  // Convert rows to CSV string
  const csv = rows
    .map(row =>
      row
        .map(field => {
          const value = field == null ? "" : String(field);
          return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
        })
        .join(",")
    )
    .join("\n");

  // Download CSV
  const filename = `${type} VisitDetails(${selectedUser.name})-${new Date().toISOString().slice(0, 10)}.csv`;
  const csvData = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
  const link = document.createElement("a");
  link.setAttribute("href", csvData);
  link.setAttribute("download", filename);
  document.body.appendChild(link); // for Firefox
  link.click();
  document.body.removeChild(link);
}


      const handleStartMonth = (value) => {
        setStart(value);
    }   

  return (
    <>
       <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                        /></a></li>
                        <li><a href="/visit-analysis"><span class="icon icon-beaker"> </span>Reports</a></li>

                        <li><a href="#"><span class="icon icon-double-angle-right"></span>Visit Date Analysis</a></li>

                    </ul>

                </div>

            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                    }}
                    className="flex-column-mobile"
                >
               <div
                className="d-flex flex-wrap align-items-end gap-3"
                style={{ marginBottom: '20px' }}
                >
                {/* User Select */}
                {Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.USER_DROPDOWN && (
                  <div style={{ minWidth: '250px', maxWidth: '250px' }}>
                    <Form.Group className="mb-1 d-flex align-items-center gap-1">
                      <Form.Label style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>Users</Form.Label>
                      <div style={{ flex: 1 }}>
                        <Select
                          className="selectdoctor"
                          options={options}
                          value={selectedUser}
                          onChange={handleSelectChange}
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: '180px',
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: '#ccc',
                            }),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                )}


                {/* Start Month */}
                <div style={{ minWidth: '250px', maxWidth: '300px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-1">
                    <Form.Label>From</Form.Label>
                    <input
                      className="form-control"
                      type="month"
                      id="start"
                      name="start"
                      onChange={(e) => handleStartMonth(e.target.value)}
                      value={start}
                    />
                  </Form.Group>
                </div>

                {/* End Month */}
                <div style={{ minWidth: '250px', maxWidth: '250px' }}>
                  <Form.Group className="mb-1 d-flex align-items-center gap-1">
                    <Form.Label>To</Form.Label>
                    <input
                      className="form-control"
                      type="month"
                      id="end"
                      name="end"
                      onChange={(e) => setEnd(e.target.value)}
                      value={end}
                    />
                  </Form.Group>
                </div>

                {/* Type Select */}
                <div style={{ minWidth: '250px', maxWidth: '300px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-1">
                    <Form.Label>Type</Form.Label>
                    <Select
                      className="selectdoctor"
                      options={typeoptions}
                      value={selectedType}
                      onChange={handleTypeChange}
                      styles={{
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          color: '#ccc'
                        })
                      }}
                    />
                  </Form.Group>
                </div>

                {/* Export Button */}
                <div style={{ minWidth: '20px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-2">
                    <Form.Label>&nbsp;</Form.Label>
                    <Button
                      className="w-100"
                      onClick={() => downloadVisitCSV(data)}
                    >
                      <RiFileExcel2Fill size={18} />
                    </Button>
                  </Form.Group>
                </div>
                </div>

                </div>
{pending ? (
  <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', height: '300px' }}>
    <LoadingComponent />
  </div>
) : (
  <div style={{display: "flex", justifyContent: 'center', alignItems: 'center', width: "100%", overflowX: "auto", padding: "10px 0" }}>
    {data.length > 0 ? (
      <div className="pt-3 overflow-x-auto" style={{ height:"60vh",overflowY: "auto", width: "100%",scrollbarWidth: "thin" }}>
        <table className="tg" >
          <thead className="bg-gray-200">
            <tr>
              <th rowSpan="3" className="tg-0pky px-2">{selectedType.label}</th>
              <th rowSpan="3" className="tg-0pky px-2">Category</th>
              <th rowSpan="3" className="tg-0pky px-2">Territory</th>
              <th rowSpan="3" className="tg-0pky px-2">Month</th>
              <th rowSpan="3" className="tg-0pky px-2">Total Visits</th>
              <th rowSpan="3" className="tg-0pky px-2">Date</th>
              <th rowSpan="3" className="tg-0pky px-2">MR Name</th>
              <th rowSpan="3" className="tg-0pky px-2">Joined With</th>
              <th rowSpan="3" className="tg-0pky px-2">Sample Product</th>
              <th rowSpan="3" className="tg-0pky px-2">Remark</th>
            </tr>
          </thead>

<tbody>
  {data.map((doctor, doctorIdx) => {
    const totalVisits = doctor.months.reduce((acc, m) => acc + m.visitDateAnalysisInners.length, 0);

    let visitCountSoFar = 0;

    return doctor.months.map((monthObj, monthIdx) => (
      <React.Fragment key={`${doctorIdx}-${monthIdx}`}>
        {monthObj.visitDateAnalysisInners.map((visit, visitIdx) => {
          const isFirstVisit = visitCountSoFar === 0;
          const isFirstVisitOfMonth = visitIdx === 0;

          visitCountSoFar++;

          return (
            <tr key={`visit-${doctorIdx}-${monthIdx}-${visitIdx}`}>
              {/* Doctor, Category, Territory: show only once for all rows */}
              {isFirstVisit && (
                <>
                  <td rowSpan={totalVisits} className="tg-0pky">{doctor.dpName}</td>
                  <td rowSpan={totalVisits} className="tg-0pky">{doctor.category}</td>
                  <td rowSpan={totalVisits} className="tg-0pky">{doctor.teritory}</td>
                </>
              )}

              {/* Month and visit count: show only once per month */}
              {isFirstVisitOfMonth && (
                <>
                  <td rowSpan={monthObj.visitDateAnalysisInners.length} className="tg-0pky">{monthObj.month}</td>
                  <td rowSpan={monthObj.visitDateAnalysisInners.length} className="tg-0pky">{monthObj.visitDateAnalysisInners.length}</td>
                </>
              )}

              {/* Always show visit details */}
              <td className="tg-0pky">{visit.date}</td>
              <td className="tg-0pky">{visit.mrName}</td>
              <td className="tg-0pky">{visit.joinWorkWith || "N/A"}</td>
              <td className="tg-0pky">{visit.productName || "N/A"}</td>
              <td className="tg-0pky">{visit.remark?.trim() || "N/A"}</td>
            </tr>
          );
        })}
      </React.Fragment>
    ));
  })}
</tbody>


        </table>
      </div>
    ) : (
      <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>There are no records to display</div>
    )}
  </div>
)}

        </div>
      </Container>
    </>
  );
};

export default VisitDateAnalysis;